import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate} from 'react-router-dom';
import { Typography, Divider, Box} from '@mui/material';
import { selectProgramById, selectProgramLocationsById, createProgramLocation, deleteProgramLocation} from 'app/store/programsSlice';
import { selectLocationsByOrgId } from 'app/store/orgLocationsSlice';
import { selectChannel } from 'app/store/channelsSlice';
import dispatchSubmit from 'app/shared-components/util/dispatchSubmit';
import TitledPanel from 'app/shared-components/layout/TitledPanel';
import LocationList from 'app/shared-components/organization/LocationList';
import CardActionsBaseMenu from 'app/shared-components/util/CardActionsBaseMenu';



function ProgramLocations(props) {
  const routeParams = useParams();
  const navigate= useNavigate();
  const {groupId, programId} = routeParams;
  const orgChannel= useSelector(selectChannel(groupId));
  const permissions = orgChannel?.callerPermissions;
  const program = useSelector(selectProgramById(programId));
  const selectedLocations= useSelector(selectProgramLocationsById(programId));
  const orgLocations= useSelector(selectLocationsByOrgId(groupId));
  const filteredLocations= orgLocations.filter((location) => !selectedLocations.find(loc => loc.id === location.id));
  const dispatch = useDispatch();
  const title= program?.name + " Locations";
  const returnPath= "/apps/organization/" + groupId + "/programs";
  
  
  function addLocation(locationId) {
	dispatchSubmit({dispatch: dispatch, 
	                submitFunction: createProgramLocation({programId: programId, locationId: locationId}), 
	                successMessage:  "Location Added"});
  }
  
  function removeLocation(locationId) {
	dispatchSubmit({dispatch: dispatch, 
	                submitFunction: deleteProgramLocation({programId: programId, locationId: locationId}), 
	                successMessage:  "Location Removed"});
  }
  
  function handleGotoLocation(locationId) {
	  navigate('/location/' + locationId);
  }

  return (
	<TitledPanel title={title} returnPath={returnPath}>
	   <Box
        className="w-full border-2 flex flex-col items-center p-10 pb-20 mb-36"
        sx={{backgroundColor: (theme) => theme.palette.background.default,
             borderRadius: '5px'}}
      >
	         
		<Typography className="font-semibold mb-4 text-24">Selected Locations</Typography>
		<Divider className="w-full mb-10"  sx={{ borderBottomWidth: 2 }} />
		
		<LocationList cols="single" emptyMessage="No locations for this program" noLink
		              locations={selectedLocations} menu={RemoveLocationMenu}/>
	   </Box>  
	   
	   <Box
        className="w-full border-2 flex flex-col items-center p-10 pb-20 mb-36"
        sx={{backgroundColor: (theme) => theme.palette.background.default,
             borderRadius: '5px'}}
        >
	                   
		<Typography className="font-semibold mb-4 text-24">Other Locations</Typography>
		<Divider className="w-full mb-10"  sx={{ borderBottomWidth: 2 }} />

		<LocationList cols="single" emptyMessage="No locations for this organization" noLink
		              locations={filteredLocations} menu={AddLocationMenu}/>
     	</Box> 			 
    </TitledPanel>
      
  );
  
  function AddLocationMenu(props) {
	  const { location } = props;
	  const allItems= [];
	  
	  allItems.push({onClick: () => handleGotoLocation(location.id), 
	                 key: "gotoLocation", 
	                 icon: "heroicons-outline:arrow-right", 
	                 text: "View Location"});
	  
	  if (permissions.owner || permissions?.admin) 
	              allItems.push({onClick: () => addLocation(location.id), 
	                             key: "addLocation", 
	                             icon: "heroicons-outline:plus-circle", 
	                             text: "Add Location"});
	  
	  return (
		<CardActionsBaseMenu items={allItems} />
	  );
   }
	
   function RemoveLocationMenu(props) {
	  const { location } = props;
	  const allItems= [];
	  
	  allItems.push({onClick: () => handleGotoLocation(location.id), 
	                 key: "gotoLocation", 
	                 icon: "heroicons-outline:arrow-right", 
	                 text: "View Location"});
	  
	  if (permissions.owner || permissions?.admin) 
	              allItems.push({onClick: () => removeLocation(location.id), 
	                             key: "removeLocation", 
	                             icon: "heroicons-outline:minus-circle", 
	                             text: "Remove Location"});
	  
	  return (
		<CardActionsBaseMenu items={allItems} />
	  );
   }
}

export default ProgramLocations;
